import {
    SETUP,
    FETCH_META,
    FETCH_COMMON_IMAGES
} from '../actions/types';

const INITIAL_STATE = {
    posSuppliers: [],
    paymentTerminals: [],
    commonImages: [],
    flowTypes: [],
    industries: [],
    themeOptions: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SETUP:
            return { ...state, ...action.payload.meta };
        case FETCH_META:
            return { ...state, ...action.payload };
        case FETCH_COMMON_IMAGES:
            return { ...state, commonImages: action.payload };
        default:
            return state;
    }
};
